import { SpDropdownToggle } from 'components/shared/Dropdown';
import { useToggle } from 'hooks/useToggle';
import { MouseEvent } from 'react';
import { Dropdown, DropdownDivider, DropdownItem, DropdownMenu } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { ClearAllDropdownItem } from 'routes/essential-workspace/components/clear-all-item';
import { useCloseCurrentTab } from 'routes/essential-workspace/components/header/hooks';
import { AdvancedDropdownItem } from 'routes/essential-workspace/components/header/more-actions/advanced-item';
import { ImportQuoteDropdownItem } from 'routes/essential-workspace/components/import-quote-item';

import './style.scss';

type Props = {
  onEditTabName: Nullable<() => void>;
};

export function HeaderMoreActionsDropdown({ onEditTabName }: Props) {
  const modalRoot = document.getElementById('modal-root')!;
  const { formatMessage } = useIntl();
  const { isOn: isDropdownOpened, toggle: toggleDropdown } = useToggle();
  const closeTab = useCloseCurrentTab();

  const handleEditTab = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    onEditTabName?.();
  };
  return (
    <Dropdown show={isDropdownOpened} onToggle={toggleDropdown}>
      <SpDropdownToggle
        caret={false}
        variant="link"
        className="btn-icon px-0"
        color="flat-secondary"
        size="lg"
        aria-label={formatMessage(
          { id: 'essential.workspace.more.actions.btn.ariaLabel' },
          { openOrClose: isDropdownOpened ? 'Close' : 'Open' },
        )}
      >
        <i className="icon">more_vert</i>
      </SpDropdownToggle>
      {createPortal(
        <DropdownMenu aria-label="actions menu" role="menu" className="header-more-menu-index">
          {onEditTabName && (
            <DropdownItem onClick={handleEditTab} role="menuitem" as="button">
              <FormattedMessage id="essential.workspace.edit.quote.btn" />
            </DropdownItem>
          )}
          <ImportQuoteDropdownItem />
          <AdvancedDropdownItem />
          <DropdownDivider />
          <DropdownItem onClick={closeTab} className="text-danger" role="menuitem" as="button">
            <FormattedMessage id="essential.workspace.delete.quote.btn" />
          </DropdownItem>
          <ClearAllDropdownItem />
        </DropdownMenu>,
        modalRoot,
      )}
    </Dropdown>
  );
}
